<template>
  <div>
    <!-- Gift Modal -->
    <b-modal
      v-if="selectedGift"
      v-model="giftModal"
      centered
      hide-header-close
      hide-footer
      size="sm"
      :title="hostName + ' için hediye'"
    >
      <div class="gifts-modal">
        <h4>{{ selectedGift.label }}</h4>
        <b-img
          :src="getImgGift(selectedGift.image)"
          width="128"
          :alt="selectedGift.label"
        />
        <h4 v-if="userGender === 'male'">
          {{ selectedGift.credits }} Elmas
        </h4>
        <b-button
          variant="primary"
          block
          :disabled="loading"
          @click="sendGift"
        >
          {{ $t('Send') }}
        </b-button>
        <b-button
          variant="outline-dark"
          size="sm"
          :disabled="loading"
          @click="hideGiftModal(true)"
        >
          {{ $t('Choose Another Gift') }}
        </b-button>
      </div>
    </b-modal>

    <!-- Choose Gift Modal -->
    <b-modal
      v-model="chooseGiftModal"
      body-class="choose-gift-modal-body"
      scrollable
      hide-footer
      size="lg"
    >
      <div class="choose-gift-modal">
        <div
          v-for="gift in availableGifts"
          :key="gift.productId"
          class="gift"
        >
          <b-img
            width="64"
            :alt="gift.label"
            :src="getImgGift(gift.image)"
            class="gift-image"
            @click="isHost ? null : showGiftModal(gift)"
          />
          <p v-if="!isHost" class="gift-price">
            <b-img
              :src="iconDiamonds1"
              width="16"
              height="16"
              style="margin-top: -2px"
            />
            {{ numberFormat(gift.credits) }}
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BImg, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError } from '@/helpers/helpers'

const iconDiamonds1 = require('@/assets/images/icons/diamonds-1.svg')

export default {
  name: 'VoiceRoomGiftModal',

  components: {
    BModal,
    BImg,
    BButton,
  },

  props: {
    hostName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      chooseGiftModal: false,
      giftModal: false,
      selectedGift: null,
      loading: false,
      iconDiamonds1,
    }
  },

  computed: {
    userGender() {
      return this.$store.getters['auth/userGender']
    },
    ...mapGetters('voiceRoom', ['isHost', 'availableGifts']),
  },

  created() {
  },

  methods: {
    getImgGift(name) {
      try {
        if (typeof name === 'object' && name.default) {
          return name.default
        }
        // eslint-disable-next-line global-require,import/no-dynamic-require
        return require(`@/assets/images/gifts/${name}`)
      } catch (error) {
        // eslint-disable-next-line global-require,import/no-dynamic-require
        return require('@/assets/images/gifts/gift.svg')
      }
    },

    hideGiftModal(showChooseAnotherGift = false) {
      this.selectedGift = null
      this.giftModal = false
      if (showChooseAnotherGift) this.chooseGiftModal = true
    },

    sendGift() {
      this.loading = true
      const data = {
        productCode: this.selectedGift.productCode,
      }
      useJwt.sendVoiceRoomGift(data)
        .then(() => {
          this.hideGiftModal()
          this.$emit('gift-sent', {
            gift: this.selectedGift,
            sender: {
              id: this.$store.getters['auth/userId'],
              name: this.$store.getters['auth/userName'],
              avatar: this.$store.getters['auth/userAvatar'],
              level: this.$store.getters['auth/userLevel'],
            },
          })
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },

    showGiftModal(gift) {
      this.selectedGift = gift
      this.chooseGiftModal = false
      this.giftModal = true
    },

    openChooseGiftModal() {
      this.chooseGiftModal = true
    },

    numberFormat(number) {
      const num = Number(number)
      if (isNaN(num)) {
        console.warn('[numberFormat] Invalid number received:', number)
        return '0'
      }
      return new Intl.NumberFormat('tr-TR').format(num)
    },
  },
}
</script>

<style lang="scss" scoped>
.choose-gift-modal {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 16px;
  padding: 16px;

  .gift {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    .gift-image {
      width: 64px;
      height: 64px;
      object-fit: contain;
    }

    .gift-price {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      color: #333;
    }
  }
}

.gifts-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px;

  h4 {
    margin: 0;
    text-align: center;
  }

  .btn {
    width: 100%;
  }
}
</style>
